import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EcomInactivationRequestDtoModel } from "../../data-transfer-objects/ecom-inactivation-request-dto.model";
import { ApiVisa, BasicApiResponseModel, Core2Config } from "../shared";

@Injectable()
export class EcomInactivationService {

    protected readonly endpoint_path = Core2Config.TENANT_ECOM_URL_PREFIX + 'identity/';

    constructor(protected readonly http: HttpClient) {}

    public crateInactivationRequest(visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
        return this.http.post<BasicApiResponseModel<any>>(visa.api_domain_url + this.endpoint_path + 'inactivation_init/login-entity-ep', null, { headers: new HttpHeaders({ 'Content-Type': 'application/json', authorization: visa.jwt_secret, tenantCode: visa.tenantCode? visa.tenantCode : '', appId: visa.applet_code? visa.applet_code : 'none' }) });
    }

    public verifyOtp(requestData: EcomInactivationRequestDtoModel, visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
        return this.http.post<BasicApiResponseModel<any>>(visa.api_domain_url + this.endpoint_path + 'inactivation_verify/login-entity-ep', requestData, { headers: new HttpHeaders({ authorization: visa.jwt_secret, tenantCode: visa.tenantCode? visa.tenantCode : '', appId: visa.applet_code? visa.applet_code : 'none' }) });
    }
}
